export const DEFAULT_COUNTRY_FLAG_CODE = "empty";
